import React, { useEffect, useState } from "react";
import { Row, Col, Image, Spin } from "antd";
import { fetchPhotos } from "../../http/photoAPI";
import { $host } from "../../http";
import "./index.scss";

const Gallery = () => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPhotos = async () => {
      try {
        const data = await fetchPhotos();
        setPhotos(data);
      } catch (err) {
        console.error("Error fetching gallery:", err);
      } finally {
        setLoading(false);
      }
    };
    loadPhotos();
  }, []);

  if (loading) {
    return <Spin size="large" style={{ display: "block", margin: "50px auto" }} />;
  }

  return (
    <div className="gallery-container">
      <h2 className="gallery-title">Photo Gallery</h2>
      <Image.PreviewGroup>
        <Row className="gallery-row">
          {photos.slice(0, 12).map((url, index) => (
            <Col flex="1 0 22%" key={index}>
              <Image
                src={`${$host.defaults.baseURL}photos/${url.img_main}`}
                alt={`gallery-${index}`}
                className="gallery-image"
              />
            </Col>
          ))}
        </Row>
      </Image.PreviewGroup>
    </div>
  );
};

export default Gallery;
